import axios from 'axios';
var url = "/api/";

export const HTTP = axios.create({
	baseURL: url
});

export const HTTPRoot = axios.create();
